import axios from "axios";

export const httpInstance = axios.create({
  baseURL: "https://web3.sgroupcentral.com/authorize",
  headers: {
    "Content-type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});
